import ToolShell, { OutputBlock, HookRow } from "@/pages/tools/ToolShell";

export default function HookBank() {
  return (
    <ToolShell
      testid="tool-hook-bank-page"
      eyebrow="Tool" toolKey="hook"
      title="Hook Bank"
      subtitle="Bulk-generate on-brand hooks across the six archetypes."
      endpoint="/tools/hook-bank"
      fields={[
        { key: "topic", label: "Topic or angle", type: "textarea", rows: 3, required: true, placeholder: "e.g. Buoyancy mistakes most divers don't notice" },
        { key: "count", label: "How many hooks?", type: "number", defaultValue: 20, min: 6, max: 48 },
      ]}
      renderOutput={(o) => (
        <OutputBlock testid="output-hook-bank" label="Hook Bank" copyValue={(o.hooks || []).map(h => h.text).join("\n")}>
          {(o.hooks || []).map((h, i) => (
            <HookRow key={i} hook={h.text} archetype={h.archetype} trigger={h.trigger} />
          ))}
        </OutputBlock>
      )}
    />
  );
}
